import React from "react";
import { Link } from "react-router-dom";
import astrologerImg from "../../assets/image/AB_Chat.jpg";
import bgImg from "../../assets/image/AB .jpg";

const ChatBanner = () => {
  const bannerStyle = {
    container: {
      position: "relative",
      width: "calc(100% - 60px)",
      maxWidth: "1400px",
      height: "auto",
      minHeight: "250px",
      margin: "40px auto 40px",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0px 50px",
      background: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('${bgImg}')`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    },
    sparkles: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      backgroundImage: `
        radial-gradient(2px 2px at 10% 20%, #ff69b4, rgba(255, 105, 180, 0)),
        radial-gradient(2px 2px at 30% 70%, #ffd700, rgba(255, 215, 0, 0)),
        radial-gradient(1px 1px at 50% 50%, white, rgba(255, 255, 255, 0))
      `,
      backgroundSize: "200% 200%",
      animation: "sparkle 6s ease-in-out infinite",
    },
    content: {
      position: "relative",
      zIndex: 2,
      flex: "1",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      color: "white",
      maxWidth: "60%",
      textAlign: "left",
      paddingTop: "20px",
      paddingBottom: "30px",
    },
    flatLabel: {
      fontSize: "clamp(22px, 2.5vw, 32px)",
      fontWeight: "900",
      fontFamily: "'Georgia', serif",
      letterSpacing: "1px",
      marginTop: "5px",
      marginBottom: "0px",
      lineHeight: "1",
    },
    heading: {
      fontSize: "clamp(30px, 4.5vw, 55px)",
      fontWeight: "bold",
      lineHeight: "1.3",
      marginTop: "6px",
      marginBottom: "15px",
      fontFamily: "'Georgia', serif",
    },
    yellowBoxSecond: {
      backgroundColor: "#ffff00",
      color: "#000",
      padding: "2px 12px",
      borderRadius: "4px",
      display: "inline-block",
      fontWeight: "bold",
      marginTop: "8px",
    },
    yellowBox: {
      backgroundColor: "#ffff00",
      color: "#000",
      padding: "2px 12px",
      borderRadius: "4px",
      display: "inline-block",
      fontWeight: "bold",
    },
    rechargeText: {
      fontSize: "clamp(16px, 2.2vw, 28px)",
      fontWeight: "500",
      marginBottom: "20px",
      marginTop: "0px",
      color: "#ffffff",
      fontFamily: "'Georgia', serif",
    },
    promoWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
      marginTop: "5px",
    },
    promoLabel: {
      fontSize: "clamp(18px, 2.5vw, 32px)",
      fontWeight: "500",
      fontFamily: "'Georgia', serif",
    },
    promoCode: {
      backgroundColor: "white",
      color: "#89184a",
      padding: "5px 20px",
      margin: "10px",
      borderRadius: "10px",
      fontSize: "clamp(20px, 3vw, 38px)",
      fontWeight: "700",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
    },
    // Image section — taller + bottom-aligned so character shows fully
    astrologersSection: {
      position: "relative",
      zIndex: 2,
      flex: "0 0 auto",
      width: "clamp(220px, 38vw, 480px)",
      height: "340px",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-end",
      marginBottom: "-0px",
    },
    astrologerImage: {
      width: "100%",
      height: "110%",           // slightly overflow bottom so figure fills nicely
      objectFit: "contain",
      objectPosition: "bottom center",
      display: "block",
    },
    terms: {
      position: "absolute",
      bottom: "10px",
      left: "50px",
      fontSize: "11px",
      color: "rgba(255, 255, 255, 0.8)",
      zIndex: 2,
    },
  };

  return (
    <>
      <style>{`
        @keyframes sparkle {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
        @media (max-width: 1024px) {
          .banner-astrologers {
            width: 320px !important;
            height: 300px !important;
          }
        }
        @media (max-width: 768px) {
          .banner-container {
            padding: 25px 20px !important;
          }
          .responsive-wrapper {
            flex-direction: column !important;
            text-align: center !important;
          }
          .banner-content {
            max-width: 100% !important;
            align-items: center !important;
            padding-bottom: 10px !important;
          }
          .banner-astrologers { display: none !important; }
          .tc-text {
            left: 0 !important;
            width: 100% !important;
            text-align: center !important;
          }
        }
      `}</style>

      <div style={bannerStyle.container} className="banner-container">
        <div style={bannerStyle.sparkles}></div>

        <div
          style={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
          className="responsive-wrapper"
        >
          {/* LEFT — Text Content */}
          <div style={bannerStyle.content} className="banner-content">
            <div style={bannerStyle.flatLabel}>GET UPTO</div>

            <h1 style={bannerStyle.heading}>
              <span style={bannerStyle.yellowBox}>20% OFF</span> on <br />
              <span style={bannerStyle.yellowBoxSecond}>
                First Recharge
              </span>
            </h1>

            <p style={bannerStyle.rechargeText}>
              Minimum Recharge = ₹100
            </p>

            <div style={bannerStyle.promoWrapper}>
              <span style={bannerStyle.promoLabel}>Promo Code</span>
              <div style={bannerStyle.promoCode}>ASTRO20</div>
            </div>
          </div>

          {/* RIGHT — Astrologer Image */}
          <div style={bannerStyle.astrologersSection} className="banner-astrologers">
            <img
              src={astrologerImg}
              alt="Astrologers"
              style={bannerStyle.astrologerImage}
            />
          </div>
        </div>

        <div style={bannerStyle.terms} className="tc-text">
          Terms and conditions applied
        </div>
      </div>
    </>
  );
};

export default ChatBanner;
